<!--
  - Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <page>
    <template v-slot:content>
      <div class="page">
        articles list
      </div>
    </template>
  </page>
</template>

<script>
import Page from "./../common/page";

export default {
  components: {
    Page
  },
  metaInfo: {
    title: "Article"
  },
  async mounted() {
    // this.article = await Article.get(this.$route.params.idOrName);
  }
};
</script>
<style lang="scss" scoped>
@import "./../../styles/index";
@import "./page-scoped";
</style>
